import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(tenantId: string): Promise<Optional<ResponseData>> {
	const url: string = `${SERVICEBASEURL.USER}/TenantNode/${tenantId}`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	data: ResponseData;
}

export type ResponseData = {
	id: string;
	name: string;
	parentId: string | null;
	metadata: Record<string, any> | null;
	createdDateUtc: string;
	updatedDateUtc: string | null;
	isDeleted: boolean;
};
